import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from 'src/store/hooks';
import { setShopifyVariants } from 'src/store/signup';
import { getShopifyVariantList } from 'src/services';

/**
 * Fetches the Shopify variant list and stores it in Redux.
 * If variants are already loaded, the API call is skipped.
 * Returns the variants from the Redux store.
 */
export const useShopifyVariants = () => {
  const dispatch = useAppDispatch();
  const shopifyVariants = useAppSelector(state => state.signUp.shopifyVariants);

  useEffect(() => {
    let active = true;
    (async () => {
      try {
        const response = await getShopifyVariantList();
        if (active && response?.data?.success && response?.data?.data) {
          dispatch(setShopifyVariants(response.data.data));
        } else if (active) {
          dispatch(setShopifyVariants([]));
        }
      } catch (error) {
        console.error('Failed to get shopify variants', error);
        if (active) {
          dispatch(setShopifyVariants([]));
        }
      }
    })();
    return () => {
      active = false;
    };
  }, [dispatch]);

  return shopifyVariants;
};
